import { Box, Typography } from '@atgfr8/atg-ui-tailwind';
import { SiteTitle } from '@components/SiteTitle/SiteTitle';

import cls from './classes';

const NewCustomerHeader = () => {
  return (
    <Box
      class={cls.headerContainer}
      alignItems="center"
      backgroundColor="white"
      width="100%"
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Typography variant="h5" class="pl-6!">
          New Customer
        </Typography>
      </Box>
      <SiteTitle title={'New Customer'} />
    </Box>
  );
};

export default NewCustomerHeader;
